import style from "./layout-container.scss";

const LayoutContainer = ({children, haveHeader, innerClass, haveFooter}) => (
    <div className={`${style.layoutContainer} ${haveHeader && style.haveHeader} ${haveFooter && style.haveFooter} ${innerClass}`}>
        {children}
    </div>
);

export default LayoutContainer;
